<footer class="main-footer">
  <strong>Copyright &copy; 2021 </strong>
  All rights reserved.
  <div class="float-right d-none d-sm-inline-block">
    <b>AKRAM S.A.R.L.</b>
  </div>
</footer>